// extracted by mini-css-extract-plugin
export default {"GateBody":"parser_GateBody__CvEwp","DecimalsInput":"parser_DecimalsInput__2pWnV","DisabledWidget":"parser_DisabledWidget__8ZE+p"};